import { Color } from '@styles/theme';

import { ReviewFinding, ReviewFindingTarget, ReviewSeverity } from 'api/journey-reviews/requests';

const TRIGGERS_NODE_TYPE = 'journey_triggers';

// Highest-risk first — drives both grouping order and chip order.
export const SEVERITY_ORDER: ReviewSeverity[] = ['must_fix', 'review_recommended', 'improvement'];

export const severityColor: Record<ReviewSeverity, Color> = {
  must_fix: 'elementRed100',
  review_recommended: 'elementOrange100',
  improvement: 'elementIndigo100',
};

export type SeverityGroup = {
  severity: ReviewSeverity;
  findings: ReviewFinding[];
};

export const groupFindingsBySeverity = (findings: ReviewFinding[]): SeverityGroup[] => {
  return SEVERITY_ORDER.map((severity) => ({
    severity,
    findings: findings.filter((finding) => finding.severity === severity),
  })).filter((group) => group.findings.length > 0);
};

export const countFindingsBySeverity = (
  findings: ReviewFinding[],
): Record<ReviewSeverity, number> => {
  return Object.fromEntries(
    SEVERITY_ORDER.map((severity) => [
      severity,
      findings.filter((finding) => finding.severity === severity).length,
    ]),
  ) as Record<ReviewSeverity, number>;
};

type NodeRef = { id: string; type: string };

/** Triggers focus the triggers node; field findings have none, so null. */
export const resolveTargetNodeId = (
  target: ReviewFindingTarget,
  nodes: NodeRef[],
): string | null => {
  if (target.kind === 'field') {
    return null;
  }
  if (target.kind === 'trigger') {
    return nodes.find((node) => node.type === TRIGGERS_NODE_TYPE)?.id ?? null;
  }
  if (!target.id) {
    return null;
  }
  return nodes.some((node) => node.id === target.id) ? target.id : null;
};
